import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { translator } from 'mage-i18n';
import { Row } from 'mage-components';
import { generateCyElemId, generateCyElemIdWithValue } from 'moet-test-utils/cypress/utils';

import { CY_APPLICATION_CONFIRMATION_CONTAINER_IDS } from '../containers/ApplicationConfirmation/constants';
import SummaryColumn from './SummaryColumn';
import SummarySection from './SummarySection';

const tPrefix = 'products-fe.components.stakeholders.form';

const {
  ADDRESS_COUNTRY,
  CITY,
  POSTAL_CODE,
  REGION,
  STREET,
} = CY_APPLICATION_CONFIRMATION_CONTAINER_IDS;

const AddressSummary = ({
  legalName,
  t,
  address: { street, postalCode, city, country, countryKey, region },
  onEdit = null,
  title,
  forStakeholder = false,
}) => {
  const Container = forStakeholder ? React.Fragment : SummarySection;
  const props = forStakeholder ? null : { onEdit, title };

  return (
    <Container {...props}>
      <Row>
        {legalName && (
          <SummaryColumn titleKey={`${tPrefix}.legal_company_name.label`} content={legalName} />
        )}
        <SummaryColumn
          titleKey={`${tPrefix}.address.label`}
          content={street}
          {...generateCyElemId(STREET, window)}
        />
        <SummaryColumn
          titleKey={`${tPrefix}.postal_code.label`}
          content={postalCode}
          {...generateCyElemId(POSTAL_CODE, window)}
        />
        <SummaryColumn
          titleKey={`${tPrefix}.city.label`}
          content={city}
          {...generateCyElemId(CITY, window)}
        />
        <SummaryColumn
          titleKey={`${tPrefix}.country.label`}
          content={country}
          {...generateCyElemIdWithValue(ADDRESS_COUNTRY, countryKey, window)}
        />
        {region && (
          <SummaryColumn
            titleKey={`${tPrefix}.${countryKey === 'US' ? 'state.label' : 'region.label_summary'}`}
            content={
              countryKey === 'US'
                ? t(`products-fe.options.us_states.${region}`, {}, region)
                : region
            }
            {...generateCyElemId(REGION, window)}
          />
        )}
      </Row>
    </Container>
  );
};

AddressSummary.propTypes = {
  address: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  forStakeholder: PropTypes.bool,
  legalName: PropTypes.string,
  title: PropTypes.string,
  onEdit: PropTypes.func,
};

export default connect(state => ({ t: translator(state) }))(AddressSummary);
